import React, { useEffect } from 'react'

import appsPlaceholder from "assets/images/placeholders/apps-placeholder.jpg";
import musicPlaceholder from "assets/images/placeholders/music-placeholder.jpg";
import settingsPlaceholder from "assets/images/placeholders/settings-placeholder.jpg";

import { useParams } from "react-router-dom";
import { View } from "../storage/routes";
import { displayModal, MODAL_CLOSE_TYPE } from '../storage/emitter'

export const PLACEHOLDER_IMAGE = {
  apps: appsPlaceholder,
  music: musicPlaceholder,
  settings: settingsPlaceholder,
};

const Placeholder = () => {
  const { type } = useParams();

  console.log("Placeholder Loaded:", type);

  useEffect(() => {
    displayModal("demo", MODAL_CLOSE_TYPE.BACK);
  }, []);

  return (
    <View>
      <div id={type} style={{ display: "block", height: "100%" }}>
        <img
          src={PLACEHOLDER_IMAGE[type]}
          alt={type}
          style={{ display: "block", width: "100%" }}
        />
      </div>
    </View>
  );
};

export default Placeholder;
